import Container from '@brands/Components/Container/Container';
import styles from '@brands/Dashboard/Dashboard/Provider/styles.module.scss';
import { selectAuth } from '@brands/store/selectors/auth';
import { AuthState } from '@brands/store/slices/authSlice';
import cn from 'classnames';
import React from 'react';

import { useWindowSize } from '../../hooks';
import { useAppSelector } from '../../hooks/useReduxHook';
import { UserRoleName } from '../../services/identity/types/UserProfile';
import NotFoundPage from '../NotFoundPage/NotFoundPage';
import Schedule from './Provider/Sections/Schedule/Schedule';

const ScheduleAvailability: React.FC = () => {
  const user: AuthState = useAppSelector(selectAuth);
  const screenSize = useWindowSize();

  const roleName = user.userInfo?.role.name;
  if (roleName !== UserRoleName.CareAdvisor && roleName !== UserRoleName.Provider) {
    return <NotFoundPage />;
  }

  // CA users are already inside CareAdvisorLayout which provides its own
  // Container + sidebar. Wrapping in a second Container causes double
  // padding and double Sidenav. Render Schedule content directly.
  if (roleName === UserRoleName.CareAdvisor) {
    return (
      <div
        className={cn(styles.containerPf, styles.providerDashboardBody)}
        style={{
          display: 'flex',
          flexDirection: 'column',
          paddingTop: '2rem',
          overflowY: 'auto',
          height: '100%',
          backgroundColor: '#F5F5F5',
        }}
      >
        <Schedule />
      </div>
    );
  }

  return (
    <Container
      containerStyle={{
        justifyContent: 'start',
      }}
      childClassName={styles.providerDashboard}
      childrenStyle={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        alignItems: 'center',
        paddingTop: '2rem',
        height: 'calc(100vh - 64px)',
        backgroundColor: '#F5F5F5',
      }}
      isProvider
      grayBackground={screenSize.width > 768}
    >
      <div
        className={cn(styles.containerPf, styles.providerDashboardBody)}
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        <Schedule />
      </div>
    </Container>
  );
};

export default ScheduleAvailability;
